import type { ReactNode } from 'react'
import { Search } from 'lucide-react'
import { Input } from '@/components/ui/Input'
import { Button } from '@/components/ui/Button'

/** Primeiro e último dia do mês corrente (YYYY-MM-DD), sem shift de timezone. */
export function currentMonthRange(): { from: string; to: string } {
  const now = new Date()
  const fmt = (d: Date) =>
    `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
  return {
    from: fmt(new Date(now.getFullYear(), now.getMonth(), 1)),
    to:   fmt(new Date(now.getFullYear(), now.getMonth() + 1, 0)),
  }
}

/**
 * Barra de filtro de período (obrigatório) reutilizada pelos relatórios.
 * `extra` permite injetar filtros adicionais (ex.: estado/cidade).
 */
export function ReportFilters({ from, to, onFrom, onTo, onApply, loading, extra }: {
  from: string
  to: string
  onFrom: (v: string) => void
  onTo: (v: string) => void
  onApply: () => void
  loading?: boolean
  extra?: ReactNode
}) {
  return (
    <div className="bg-white rounded-md ring-1 ring-gray-200 p-4 sm:p-5 mb-4">
      <div className="flex flex-wrap items-end gap-3">
        <Input
          label="Data inicial" type="date" required value={from}
          onChange={(e) => onFrom(e.target.value)} clearable={false}
          wrapperClassName="w-40"
        />
        <Input
          label="Data final" type="date" required value={to}
          onChange={(e) => onTo(e.target.value)} clearable={false}
          wrapperClassName="w-40"
        />
        {extra}
        <Button onClick={onApply} loading={loading} iconLeft={<Search size={14} />}>Aplicar</Button>
      </div>
    </div>
  )
}
